module.exports = __webpack_public_path__ + "img/white_paper18.2e3bb1ec.png";